
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"84","height":"78","viewBox":"0 0 84 78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 67.9l29.67-26.96L75.3 1l1.68 1.85-44.71 41.7L2.98 71.18 0 67.9zM5.96 74.46L35.62 47.5 81.37 7.68l1.68 1.86-44.82 41.57-29.3 26.62-2.97-3.27z"}})])
          )
        }
      }
    